import tree from 'state';
import {canUseDOM} from 'exenv';

export function hasSession() {
  const session = tree.get(['authentication', 'session']);
  return session || (canUseDOM && window.OFFLINE_MODE)
}

